import { Colors } from '@src/colors';
import styled, { css } from 'styled-components';

export const Alert = styled.div<{ alertType: 'error' | 'warning' }>`
    padding: 30px 35px;

    ${(props) =>
        props.alertType === 'error'
            ? css`
                  border: 1px solid ${Colors.alert};
                  background-color: ${Colors.alert10};
              `
            : css`
                  border: 1px solid ${Colors.awareness};
                  background-color: ${Colors.awareness10};
              `}

    display: inline-flex;
    margin: 0;
    width: auto;
    min-width: 247px;
    align-items: center;

    font-family: Public Sans;
    font-size: 14px;
    line-height: 16px;

    > svg {
        height: 30px;
        width: 30px;
        margin-right: 18px;

        ${(props) =>
            props.alertType === 'warning' &&
            css`
                path {
                    fill: ${Colors.awareness};
                }
            `}
    }
`;

export const Title = styled.p`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 14px;
    line-height: 16px;

    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 5px;
    font-feature-settings:
        'ss06' on,
        'case' on;

    color: #${Colors.primaryDusk};
`;

export const Message = styled.div`
    word-break: break-word;
    /* Body/Regular */

    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
    /* identical to box height, or 150% */

    color: #${Colors.primaryDusk};
`;
